import { type ApolloClient } from '@apollo/client/core';
import {
	CurrentUserDocument,
	UseSiteDocument,
	SetUpPermissionsDocument,
} from '@/generated/graphql';

/**
 * Refresh global queries once per page load.
 *
 * These queries use `cache-first` to avoid redundant network requests when
 * multiple components use the same data. This function ensures the cache is
 * populated with fresh data from the server on each page load.
 *
 * Runs in the background — does not block rendering.
 */
export const refreshGlobalQueries = (apollo: ApolloClient<unknown>) => {
	const queries = [
		CurrentUserDocument,
		UseSiteDocument,
		SetUpPermissionsDocument,
	];

	queries.forEach((query) => {
		apollo.query({ query, fetchPolicy: 'network-only' });
	});
};
